// ====== frontend/src/pages/Home.js
import { Link } from 'react-router-dom'
import Header from '../Header'
import Footer from '../Footer'
import Join from '../Join'
import Video_Junior from '../Video_Junior'
import { useNavigate } from 'react-router-dom';

import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

import { useForm } from "react-hook-form";
// ==========
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Supporters from '../Supporters'
import Subscribe_layout from '../Subscribe_layout'
import AudioPlayer from './AudioPlayer'
import WaveformAudioPlayer from '../components/WaveformAudioPlayer'
const images = [
  "./images/building/1.png",
  "./images/building/2.png",
  "./images/building/3.png",
  "./images/building/4.png",
  "./images/building/5.png",
  "./images/building/6.png",
  "./images/building/7.png",
  "./images/building/8.png",
];


function Home() {

  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const [error, setError] = useState("")

  async function addData(e) {
    e.preventDefault();
    setError("")
    if (name && phone && email) {

      console.warn(name, phone, email)
      const formData = new FormData();
      formData.append('name', name);
      formData.append('phone', phone);
      formData.append('email', email);
      try {
        let result = await fetch("https://juniorpersist.com/public/public/api/addGainAccess", {
          method: 'POST',
          body: formData
        });
        navigate('/Preview')
      } catch (error) {
        console.log(error);
      }
    } else {
      setError("Error: all fields required");
    }
  }


  // ======Model
  const [show, setShow] = useState(false);

  // =================================

  // ================================Model======================
  const [showModal, setShowModal] = useState(null);

  const handleShow = (modalName) => {
    setShowModal(modalName);
  };

  const handleClose = () => {
    setShowModal(null);
  };
  return (

    <div>
      <Header />

      {/* Mobile-only responsive rules for this page. Wrapped entirely in
          a max-width media query so nothing here can ever affect desktop
          — desktop keeps using the exact same classes/layout as before,
          untouched. */}
      <style>{`
        @media (max-width: 576px) {
          /* ---- Hero ---- */
          .home-hero-mobile { padding: 0 20px 24px; text-align: center; }
          .home-hero-mobile-img { width: 62%; max-width: 260px; margin: 6px auto 4px; display: block; }
          .home-hero-mobile-title { font-size: 26px; font-weight: 700; margin: 14px 0 4px; }
          .home-hero-mobile-subtitle { font-size: 14px; font-weight: 500; opacity: .75; margin-bottom: 10px; }
          .home-hero-mobile-desc { font-size: 14px; line-height: 1.6; margin-bottom: 18px; }
          .home-hero-mobile-actions { display: flex; flex-direction: column; gap: 10px; margin-bottom: 18px; }
          .home-hero-mobile-actions a, .home-hero-mobile-actions button {
            width: 100% !important; margin: 0 !important; display: block !important;
          }
          .home-hero-mobile-access { font-size: 17px !important; padding: 8px 24px !important; }

          /* ---- Part 2: trailer + "discover what's inside" card ---- */
          .part2 { padding-top: 28px !important; padding-bottom: 28px !important; }
          .space876 { margin-top: 22px !important; }
          .part2_right { margin-top: 22px; border-radius: 14px; }

          /* ---- Videos row: comfortable one-and-a-peek horizontal scroll ---- */
          .jett_scrollmenu_in { min-width: 82% !important; scroll-snap-align: start; }
          .jett_scrollmenu { scroll-snap-type: x mandatory; -webkit-overflow-scrolling: touch; }

          /* ---- Share-the-book banner overlay text ---- */
          .NewBox1_title { font-size: 20px !important; line-height: 1.35 !important; }
          .NewBox1_text1 { font-size: 13px !important; }
          .NewBox1_text2 { font-size: 15px !important; }
        }

        /* Landscape phones specifically — max-width alone doesn't catch
           this: a phone rotated sideways is often 700-930px WIDE (past the
           576px breakpoint above) but only ~350-430px TALL. Targeting a
           short viewport height + landscape orientation is what actually
           identifies "phone turned sideways", regardless of exact width,
           without accidentally catching landscape tablets (which have
           plenty of height and don't need this). */
        @media (max-height: 500px) and (orientation: landscape) {
          .part2 { padding-top: 14px !important; padding-bottom: 14px !important; }
          .text2_part22 { font-size: 19px !important; margin-bottom: 2px !important; }
          .text2_part22_1 { font-size: 11.5px !important; margin-bottom: 6px !important; line-height: 1.3 !important; }
          .video_new8745 { margin: 6px 0 !important; }
          .video875 { max-height: 34vh !important; width: 100% !important; object-fit: cover !important; }
          .home_new_text1.space876 { margin-top: 10px !important; padding-top: 10px !important; font-size: 12px !important; }
          .space877 { margin-top: 4px !important; }
          .part2_right { padding-top: 12px !important; padding-bottom: 12px !important; }
          .text1_part2 { font-size: 15px !important; }
          .text2_part2 { font-size: 12px !important; margin-bottom: 4px !important; }
          .image_2 { max-height: 80px !important; width: auto !important; }
          .kaptap_img { max-height: 34px !important; }
          .kaptab_text { font-size: 11px !important; }
        }

        /* ---- Shared "excerpt-style" modal look (used by both the READ
             BLURB summary modal and the READ SAMPLE chapter modal).
             Hoisted to this always-rendered block rather than living
             inside either Modal's own JSX — react-bootstrap doesn't mount
             a Modal's children until it's shown, so a <style> tag nested
             inside ONE modal would never load if the OTHER modal is the
             one opened first, leaving it completely unstyled. ---- */
        .excerpt-modal-dialog { max-width: 720px; }
        .excerpt-modal-content {
          background: #FBF7EF;
          border: none;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 40px 90px -30px rgba(0,0,0,.45);
          position: relative;
        }
        .excerpt-close-btn {
          position: absolute; top: 16px; right: 16px; z-index: 5;
          width: 36px; height: 36px; border-radius: 50%;
          background: rgba(42,35,24,.06); border: none; color: #2A2318;
          display: flex; align-items: center; justify-content: center; cursor: pointer;
          font-size: 15px; transition: background .15s ease;
        }
        .excerpt-close-btn:hover { background: rgba(42,35,24,.12); }
        .excerpt-scroll { max-height: 72vh; overflow-y: auto; padding: 54px 48px 0; }
        .excerpt-scroll::-webkit-scrollbar { width: 8px; }
        .excerpt-scroll::-webkit-scrollbar-thumb { background: rgba(42,35,24,.15); border-radius: 8px; }
        .excerpt-kicker {
          text-align: center; color: #B8842E; font-weight: 700; font-size: 11px;
          letter-spacing: .22em; text-transform: uppercase; margin-bottom: 22px;
          font-family: Georgia, serif;
        }
        .excerpt-chapter-num {
          text-align: center; color: #B8842E; font-family: Georgia, serif; font-style: italic;
          font-size: 14px; letter-spacing: .16em; text-transform: uppercase; margin-bottom: 6px;
        }
        .excerpt-chapter-title {
          text-align: center; color: #2A2318; font-family: Georgia, serif; font-weight: 700;
          font-size: 27px; letter-spacing: .01em; margin-bottom: 24px;
        }
        .excerpt-quote {
          text-align: center; font-family: Georgia, serif; font-style: italic; color: #8f6822;
          font-size: 19px; line-height: 1.5; max-width: 460px; margin: 0 auto 32px;
        }
        .excerpt-body {
          font-family: Georgia, 'Times New Roman', serif; font-size: 16.5px; line-height: 1.85;
          color: #2A2318; text-align: justify;
        }
        .excerpt-body p { margin: 0 0 1.15em; }
        .excerpt-body p:first-of-type::first-letter {
          float: left; font-family: Georgia, serif; font-weight: 700; font-size: 58px;
          line-height: .78; padding: 4px 8px 0 0; color: #B8842E;
        }
        .excerpt-divider {
          display: flex; align-items: center; justify-content: center; gap: 14px;
          margin: 46px 0 36px; color: #B8842E; font-size: 11px;
        }
        .excerpt-divider span { width: 60px; height: 1px; background: rgba(184,132,46,.35); }
        .excerpt-cta {
          text-align: center; padding: 30px 20px 34px; border-top: 1px solid rgba(42,35,24,.08);
          margin-top: 14px; background: rgba(184,132,46,.05);
        }
        .excerpt-cta p { color: #7A7F87; font-size: 13px; margin-bottom: 14px; font-family: Georgia, serif; font-style: italic; }
        .excerpt-cta a {
          display: inline-block; background: #B8842E; color: #fff; font-weight: 700; font-size: 14px;
          padding: 13px 34px; border-radius: 999px; text-decoration: none; transition: background .15s ease, transform .15s ease;
        }
        .excerpt-cta a:hover { background: #a0721f; color: #fff; transform: translateY(-1px); }

        /* ---- Summary modal header: cover art + book title + subtitle ---- */
        .excerpt-cover-wrap { text-align: center; margin-bottom: 20px; }
        .excerpt-cover-wrap img {
          width: 110px; border-radius: 8px;
          box-shadow: 0 20px 36px -16px rgba(0,0,0,.5);
        }
        .excerpt-book-title {
          text-align: center; color: #2A2318; font-family: Georgia, serif; font-weight: 700;
          font-size: 31px; letter-spacing: .01em; margin-bottom: 8px;
        }
        .excerpt-book-subtitle {
          text-align: center; color: #B8842E; font-family: Georgia, serif; font-style: italic;
          font-size: 15.5px; margin-bottom: 8px;
        }
        .excerpt-header-divider {
          display: flex; align-items: center; justify-content: center; gap: 12px;
          margin: 16px 0 28px; color: #B8842E; font-size: 10px;
        }
        .excerpt-header-divider span { width: 44px; height: 1px; background: rgba(184,132,46,.35); }

        @media (max-width: 576px) {
          .excerpt-scroll { padding: 46px 22px 0; }
          .excerpt-chapter-title { font-size: 22px; }
          .excerpt-body { font-size: 15.5px; text-align: left; }
          .excerpt-book-title { font-size: 24px; }
          .excerpt-book-subtitle { font-size: 13px; }
          .excerpt-cover-wrap img { width: 84px; }
        }
      `}</style>

      {/* ===========Slider */}
      <div className="slider_home_page_jett pb-1">
        <div className="">
          <div className="row">
            <div className="col-sm-5 align-self-center d-none d-sm-block">
              <center>
                <div className="left_content">
                  <img className='image_slider' src='/images/new_images/5.png' />
                </div>
              </center>
            </div>
            <div className="col-sm-7 align-self-center">
              <div className="text_slider space10">

                <div className="col-sm-10 d-none d-sm-block ">

                  <div className="text_slider2 my-4">
                    Persist, Persist, Persist.
                    <div className="text_slider5">The Haitian Boy, The American, and The Hidden Lesson</div>
                  </div>
                  <p className="text_slider3 col-sm-12 mb-4">
                    In a world that often dismisses the pursuit of dreams as a mere luxury, for Junior, it was an all-out war between life and death. Growing up in the heart of poverty in Haiti...
                  </p>
                </div>

                <div className='col-sm-6 d-none d-sm-block'>

                  <div className='btn_space_slider_home_page'>
                    <button
                      onClick={() => handleShow('summary')}
                      className="btn_buy_book px-3 mobile_home_btn1"
                      style={{ width: '48%' }}
                    >
                      <i className="bi bi-book me-1"></i> READ BLURB
                    </button>
                    &nbsp;&nbsp;
                    <Link to="/BuyBook" className="btn_preoreder px-4 mobile_home_btn1" style={{ width: '48%', display: 'inline-block' }}>BUY THE BOOK</Link>

                  </div>
                  <div style={{ marginTop: "15px" }}>
                    <center>

                      <div className="mb-1">Already have a copy?</div>

                      <a
                        href="#AccessMyBook" className="btn_access_my_book" >
                        ACCESS MY BOOK <i className="bi bi-arrow-right"></i>
                      </a>
                    </center>
                  </div>

                </div>

                {/* ====================================== */}
                {/* Single, self-contained mobile hero — replaces the old
                    fragmented version where the title/description were
                    completely missing and the two CTAs were squeezed onto
                    one line. Everything desktop-specific above is now
                    hidden on mobile (d-none d-sm-block); this block is the
                    only thing mobile visitors see, in a sensible reading
                    order: image, title, description, primary actions,
                    secondary action. */}
                <div className="d-block d-sm-none home-hero-mobile">
                  <img className="home-hero-mobile-img" src='/images/new_images/5.png' alt="Persist, Persist, Persist" />

                  <div className="home-hero-mobile-title">Persist, Persist, Persist.</div>
                  <div className="home-hero-mobile-subtitle">The Haitian Boy, The American, and The Hidden Lesson</div>
                  <p className="home-hero-mobile-desc">
                    In a world that often dismisses the pursuit of dreams as a mere luxury, for Junior, it was an all-out war between life and death. Growing up in the heart of poverty in Haiti...
                  </p>

                  <div className="home-hero-mobile-actions">
                    <Link to="/BuyBook" className="btn_preoreder px-4 mobile_home_btn1">BUY THE BOOK</Link>
                    <button className="btn_buy_book px-3 mobile_home_btn1" onClick={() => handleShow('summary')}>
                      <i className="bi bi-book me-1"></i> READ BLURB
                    </button>
                  </div>

                  <div className="mb-2">Already have a copy?</div>
                  <a
                    href="#AccessMyBook"
                    className="home-hero-mobile-access"
                    style={{
                      color: "#000",
                      fontSize: "18px",
                      fontWeight: "700",
                      border: "1px solid #000",
                      padding: "7px 30px",
                      borderRadius: "50px",
                      textDecoration: "none",
                      display: "inline-block",
                      textAlign: "center",
                    }}
                  >
                    ACCESS MY BOOK <i className="bi bi-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      {/* ========================Part2 */}


      <div className='container part2 py-5  '>
        <div className='row col-sm-12 jett_content_part2_23'>
          <div className='col-sm-8 jett_block_double_slider'>

            <div className='text2_part22 text-black'>WATCH THE TRAILER</div>

            <div className='text2_part22_1 mb-1'>Exclusive Edition – Available Only at JuniorPersist.com</div>
            <div className='video_new8745'>
              <video
                className='video875'
                controls
                poster="/images/new_images/cover.png"
              >
                <source src="https://res.cloudinary.com/dlhtt7jey/video/upload/v1755821110/BOOK_TRAILER_ar3vpx.mp4" type="video/mp4" />
                Tu navegador no soporta la etiqueta de video.
              </video>
            </div>


            <div className="home_new_text1 space876 opacity-25 pt-4 mb-2">FANS & SUPPORTERS</div>
            <div className='space877 '>
              <Supporters />

            </div>
          </div>

          <div className='col-sm-4 jett_block_double_slider'>
            <div className='justify-content-center part2_right shadow-lg px-3 px-sm-5 py-4 bg-white'>
              <div className=' top_part2_right'>
                <div className='text1_part2'>PURE MADNESS!</div>
                <div className='text2_part2'>DISCOVER WHAT’S INSIDE THE BOOK</div>
                <a href="#" onClick={() => handleShow('blurb')}>
                  <img className='image_2' src='/images/new_images/1.png' />
                </a>
              </div>
              {/* ================Form================ */}

              {/* <div className='form'>
                {error && <div className='error_text'>{error}</div>}
                <input className="input_part2_jett" placeholder='Name' type="text" id="name" required="" onChange={(e) => setName(e.target.value)} />
                <input className="input_part2_jett" placeholder='Phone' type="text" id="phone" required="" onChange={(e) => setPhone(e.target.value)} />
                <input className="input_part2_jett" placeholder='Email Address' type="email" id="email" required="" onChange={(e) => setEmail(e.target.value)} />
                <button type='submit' onClick={(e)=>addData(e)} className='btn_part2_jett mt-2 py-1'> GAIN ACCESS NOW</button>
              </div> */}

              <center>
                <div className='mb-2'>

                  <div className=''>
                    <a href="#" onClick={() => handleShow('blurb')}>
                      <img src={'/images/icons/kaptab/2.png'} className="kaptap_img" />
                      <div className="kaptab_text">READ SAMPLE</div>
                    </a>
                  </div>
                </div>


                <div className=''>
                  {/* ============Audio preview */}
                  <WaveformAudioPlayer src="/audio/Persist, Persist, Persist_07.mp3" />
                <div className='mt-3 opacity-75'>PREVIEW THE AUDIOBOOK</div>
                </div>


              </center>

              {/* =========Form=====================Part2-1 */}

            </div>
          </div>
        </div>

      </div>


      {/* ==================================================== */}

      <div id="AccessMyBook" className="container pb-5">
        <div className="vip-section">
          <div className="text-center mb-4">
            <h1 className="vip-title">
              VIP ACCESS
            </h1>
            <h2 className="vip-subtitle">
              UNLOCK THE FULL EXPERIENCE
            </h2>
            <div className="divider-wrapper">
              <div className="divider"></div>
              <div className="divider-gold"></div>
            </div>
          </div>

          <div className="row g-5 align-items-center">
            {/* Ebook */}
            <div className="col-lg-6">
              <div className="vip-card">
                <div className="d-flex align-items-center mb-4">
                  <div className="icon-wrapper me-3">
                    <i className="bi bi-book"></i>
                  </div>
                  <div>
                    <h3 className="feature-title">
                      EBOOK
                    </h3>
                    <p className="feature-text mb-0">
                      VIP access to <br />
                      persist, persist, persist.
                    </p>
                  </div>
                </div>
                <input
                  type="text"
                  className="form-control vip-input"
                  placeholder="Enter your special code here..."
                  readOnly
                  onClick={() => navigate('/access-ebook')}
                  style={{ cursor: 'pointer' }}
                />
                <Link to="/access-ebook" className="vip-btn">
                  ACCESS EBOOK
                </Link>
              </div>
            </div>

            {/* Audiobook */}
            <div className="col-lg-6 position-relative">
              <div className="vertical-divider d-none d-lg-block"></div>
              <div className="vip-card">
                <div className="d-flex align-items-center mb-4">
                  <div className="icon-wrapper me-3">
                    <i className="bi bi-headphones"></i>
                  </div>
                  <div>
                    <h3 className="feature-title">
                      AUDIOBOOK
                    </h3>
                    <p className="feature-text mb-0">
                      VIP access to <br />
                      persist, persist, persist.
                    </p>
                  </div>
                </div>
                <input
                  type="text"
                  className="form-control vip-input"
                  placeholder="Enter your special code here..."
                  readOnly
                  onClick={() => navigate('/access-audiobook')}
                  style={{ cursor: 'pointer' }}
                />
                <Link to="/access-audiobook" className="vip-btn">
                  ACCESS AUDIOBOOK
                </Link>
              </div>
            </div>
          </div>
          <div className="text-center mt-5 vip-footer">
            <i className="bi bi-lock-fill me-2"></i>
            Exclusive access for VIP members only.
          </div>
        </div>
      </div>




      {/* ==================================================== */}
      <div className='bg-black py-4'>
        <div id='VIDEOS' className='part3 container col-sm-9 mt-4'>
          {/* <div className="text_header_jett_89 text-center px-3 text-black mt-2">IT'S SENSATIONAL!</div>
          <center>
            <div className='text2_part3 mb-3 opacity-50 col-sm-7 py-2'>
              Discover the latest insights from the author and the buzz around the book
            </div>
          </center> */}

          <div className='text2_part22  text-white text-center mb-2'>WATCH THE LATEST VIDEOS</div>
          <div className=''>
            <div className=' jett_scrollmenu'>

              <div className='col-sm-4 py-3 jett_block_double_slider jett_scrollmenu_in'>
                <div className='part3_video_box shadow'>
                  <video
                    className='iframe_part3'
                    controls
                    poster="/images/new_images/3/1.png"
                  >
                    <source src="https://res.cloudinary.com/dlhtt7jey/video/upload/v1755827624/1_Junior_Persist_Version_pydrza.mp4" type="video/mp4" />
                    Tu navegador no soporta la etiqueta de video.
                  </video>
                  <div className='bg-white px-4 py-2'>
                    <span>Watch Junior’s Commencement Speech</span><br />
                    <span className='text_box_video_part3'>Alvernia University (2014) </span>
                  </div>
                </div>
              </div>
              <div className='col-sm-4 py-3 jett_block_double_slider jett_scrollmenu_in'>
                <div className='part3_video_box shadow'>
                  <video
                    className='iframe_part3'
                    controls
                    poster="/images/new_images/3/2.png"
                  >
                    <source src="https://res.cloudinary.com/dlhtt7jey/video/upload/v1755826598/DON8UE_-_Updated_Version_weiwdx.mp4" type="video/mp4" />
                    Tu navegador no soporta la etiqueta de video.
                  </video>
                  <div className='bg-white px-4 py-2'>
                    <span>Insights on the Book</span><br />
                    <span className='text_box_video_part3'>Here's why I wrote the book</span>
                  </div>
                </div>
              </div>

              <div className='col-sm-4 py-3 jett_block_double_slider jett_scrollmenu_in'>
                <div className='part3_video_box shadow'>
                  <video
                    className='iframe_part3'
                    controls
                    poster="/images/new_images/3/3.png"
                  >
                    <source src="https://res.cloudinary.com/dlhtt7jey/video/upload/v1755826150/Book_Review_sol9b2.mp4" type="video/mp4" />
                    Tu navegador no soporta la etiqueta de video.
                  </video>
                  <div className='bg-white px-4 py-2'>
                    <span>Review from University Professor</span><br />
                    <span className='text_box_video_part3'>Dr. Rumu's reaction to the book</span>
                  </div>
                </div>
              </div>


              <div className='col-sm-4 py-3 jett_block_double_slider jett_scrollmenu_in'>
                <div className='part3_video_box shadow'>
                  <video
                    className='iframe_part3'
                    controls
                    poster="/images/new_images/3/5.png"
                  >
                    <source src="https://res.cloudinary.com/dlhtt7jey/video/upload/v1755821120/DONE_-_Open_Doors_wzeykt.mp4" type="video/mp4" />
                    Tu navegador no soporta la etiqueta de video.
                  </video>
                  <div className='bg-white px-4 py-2'>
                    <span>Daring to Dream</span><br />
                    <span className='text_box_video_part3'>What life taught me about dreams</span>
                  </div>
                </div>
              </div>

              <div className='col-sm-4 py-3 jett_block_double_slider jett_scrollmenu_in'>
                <div className='part3_video_box shadow'>
                  <video
                    className='iframe_part3'
                    controls
                    poster="/images/new_images/3/6.png"
                  >
                    <source src="https://res.cloudinary.com/dlhtt7jey/video/upload/v1755820964/READER_S_REACTIONS_i3meip.mp4" type="video/mp4" />
                    Tu navegador no soporta la etiqueta de video.
                  </video>
                  <div className='bg-white px-4 py-2'>
                    <span>Readers' Reactions</span><br />
                    <span className='text_box_video_part3'>Readers’ voices across borders</span>
                  </div>
                </div>
              </div>



            </div>
          </div>
          {/* <div className='text-center mt-2'>
            <a href="/Video" className="h4 opacity-25">VIEW MORE</a>
          </div> */}
        </div>
      </div>
      {/* ==================================================== */}



      {/* <div className=" share_the_book" >
        <center>
          <img
            src="/images/new_images/6_1.png"
            alt="Banner"
            className="w-100 d-none d-sm-block"
          />

          <img
            src="/images/new_images/6_1_mobil.png"
            alt="Banner Mobile"
            className="w-100 d-block d-sm-none"
          />

         

          <div className='NewBox1'>
            <div className='NewBox1_title'>
              Not in bookstores. No mass distribution.
            </div>
            <div className='NewBox1_text1 py-1'>
              Just one beautiful paperback—shipped directly from me to you.
            </div>
            <div className='NewBox1_text2'>Price: $19.79</div>
            <div className='mt-4'>
              <a href="/BuyBook" className='NewBox1_btn'>Get Your Copy Now</a>
            </div>
          </div>
        </center>
      </div> */}
          {/* =========================== */}

      {/* ==========================Part 4============================= */}


      <Footer />



      {/* ================Modal=---------------------- */}

      <Modal show={showModal === 'pdf'} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Book Excerpt</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="resume_book space0098">
            <center>
              <div className="col-sm-8">
                <div className='blog_scrol_jett'>
                  <img className="image_book_mobile jett_scrollmenu_in" src={'/pdf/img_book/home_persist-1.png'} />
                  <img className="image_book_mobile jett_scrollmenu_in" src={'/pdf/img_book/home_persist-2.png'} />
                </div>
              </div>
            </center>
          </div>
          {/* ====== */}



        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* ===================================== */}

      <Modal show={showModal === 'audio'} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Audio Excerpt</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-black px-2 py-2">
            <AudioPlayer />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* ===================================== */}

      <Modal show={showModal === 'summary'} onHide={handleClose} size="lg" centered
        contentClassName="excerpt-modal-content" dialogClassName="excerpt-modal-dialog">
        <button className="excerpt-close-btn" onClick={handleClose} aria-label="Close">
          <i className="bi bi-x-lg"></i>
        </button>

        <div className="excerpt-scroll" style={{ paddingBottom: '6px' }}>
      
          <div className="excerpt-book-title">Persist, Persist, Persist.</div>
          <div className="excerpt-book-subtitle">The Haitian Boy, The American, and The Hidden Lesson</div>

          <div className="excerpt-header-divider"><span></span><i className="bi bi-star-fill"></i><span></span></div>

          <div className="excerpt-body" style={{ textAlign: 'left' }}>
            <p>In a world that often dismisses the pursuit of dreams as a mere luxury, for Junior, it was an all-out war between life and death.</p>
            <p>Growing up in the heart of poverty in Haiti, a world vividly described in this memoir, Junior embarked on an unprecedented journey—from surviving a heart-wrenching car crash to desperate street begging in the Dominican Republic. Then came the Haiti earthquake, a relentless force that snuffed out over 100k lives in less than 60 seconds.</p>
            <p>And if you think you've heard it all, think again. What lies ahead in these pages takes “persistence” to a whole new dimension—a story so gripping, so raw, that you need to read it to believe it.</p>
            <p><em>Persist, Persist, Persist.</em> is not just a memoir; it’s an electrifying, can't-put-it-down chronicle that immerses you in Junior’s thrilling journey and unveils Haiti’s narrative in a revolutionary light. A timeless tale of obsession, survival, and self-invention, intricately woven with the unforgiving twists of fate.</p>
            <p>Brace yourself for a narrative that will make you lose track of time and demand to be shared with everyone you know.</p>
          </div>

          <div className="excerpt-cta">
            <p>Ready to begin the journey?</p>
            <a href="/BuyBook">Get Your Copy &rarr;</a>
          </div>
        </div>
      </Modal>
      {/* =========================================== */}

      <Modal show={showModal === 'blurb'} onHide={handleClose} size="lg" centered
        contentClassName="excerpt-modal-content" dialogClassName="excerpt-modal-dialog">

        <button className="excerpt-close-btn" onClick={handleClose} aria-label="Close">
          <i className="bi bi-x-lg"></i>
        </button>

        <div className="excerpt-scroll">
          <div className="excerpt-kicker">Persist, Persist, Persist. &middot; Free Excerpt</div>

          <div className="excerpt-chapter-num">Chapter One</div>
          <div className="excerpt-chapter-title">Jérémie: A Town of Secrets</div>
          <div className="excerpt-quote">“The devil lived here. And he didn’t bother to hide.”</div>

          <div className="excerpt-body">
            <p>They told me to chase my dream. They never warned me it could kill me.</p>
            <p>They said, “Dream big.”<br />They said, “Work hard, and anything is possible.”</p>
            <p>But no one told me that a dream, if clung to hard enough, can burn through your life like fire. That it can blind you to danger, deafen you to warning, and drag you into places your soul was never meant to go, places your soul would beg to flee.</p>
            <p>At thirteen, I used to laugh, quietly, bitterly, at the foreign travelers who stepped onto this side of the world. They saw paradise. I saw something else entirely.</p>
            <p>They marveled at the endless blue sky, the velvet hills, the shimmering waters, the radiant birds gliding overhead, and the warm, unbreakable smiles of Haitians. To them, it was breathtaking; art, alive and moving.</p>
            <p>What they didn’t know was this:<br />The devil lived here.<br />And he didn’t bother to hide.</p>
            <p>Along the dirt streets where shacks hug the edges, blind elders and their tattered-clothed grandchildren begged for anything that fell off your plate.</p>
            <p>In the ghettos, starving children with dusty feet and chapped lips were at death’s door, drenched in their own diarrhea from the maladies they shouldered. Armies of gaunt dogs overwhelmed the streets. No electricity. No proper hospital.</p>
            <p>We called this town Jérémie. But Tragedy might’ve fit better.</p>
            <p>I can’t delve into the occurrences that were rampant across the land without first shedding light on what also made this place magnificent—a hidden treasure in the eyes of many.</p>
            <p>This town may be unlike anything you’ve ever seen. It’s a place where colorful roosters boldly strut along the roads, as if they’ve been granted a license to flaunt their freedom. The striking sight of beautiful dark-skinned women with full, expressive lips gracefully balancing buckets filled with goods on their heads, hands-free, in perfect equilibrium, would leave you breathless as they journey to and from open markets.</p>
            <p>In this town, the night preceding a funeral casts aside sorrow to celebrate the departure of a precious soul with a party of drum-beating melodies, throat-burning alcohol, and the spirited clash of dominoes. Weekends by the rivers were always bursting with a symphony of music, the sweetness of mangoes, mouthwatering goat meat with fried plantains, and laughter. Between the flight of pigeons and kites swaying to the Caribbean ocean breeze, the sky dances with liveliness until twilight yields to the art of storytelling.</p>
            <p>They nicknamed this town the City of Poets because of the brilliant minds that have walked across this land. Think of the great Émile Roumer, Etzer Vilaire, and even General Thomas-Alexandre Dumas, whose son, Alexandre Dumas, gave the world The Count of Monte Cristo and The Three Musketeers. All of them have roots here.</p>
            <p>Believe it or not, beneath the surface of apparent joy, uniqueness, and marvels that may have captivated many observers, unless you’re a local, you’d have no idea about what goes on in this town. Especially in my neighborhood.</p>
          </div>

          <div className="excerpt-divider"><span></span><i className="bi bi-star-fill"></i><span></span></div>

          <div className="excerpt-chapter-num">Chapter Two</div>
          <div className="excerpt-chapter-title">Rumors</div>
          <div className="excerpt-quote">“They’re about to raise the dead to turn them into zombies.”</div>

          <div className="excerpt-body">
            <p>You think you’ve seen Haiti? What you’ve seen is light. Let me pull you into the shadows, where the real stories begin.</p>
            <p>Across the street from us, in a tiny blue house with a tin roof, lived a…….</p>
          </div>

          <div className="excerpt-cta">
            <p>Want to know what happened next?</p>
            <a href="/BuyBook">Get Your Copy &rarr;</a>
          </div>
        </div>
      </Modal>
      {/* =========================================== */}

    </div>
  )
}


export default Home